import { createUrl } from "@/redux/api";
import {
  AnalyticsTags,
  OrganizationAnalyticsResponse,
  OrganizationAnalyticsQueryParams,
  TagType,
  EvidenceAnalyticsQueryParams,
  EvidenceAnalyticsResponse,
  UserAnalyticsQueryParams,
  UserAnalyticsResponse,
} from "@/redux/analytics/types";
import { BuilderType } from "@/redux/types";

const analyticsService = (builder: BuilderType<AnalyticsTags>) => ({
  getOrganizationAnalytics: builder.query<
    OrganizationAnalyticsResponse,
    OrganizationAnalyticsQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/analytics/organizations/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result ? [{ type: "OrganizationAnalytics" }] : [],
  }),
  getUserAnalytics: builder.query<
    UserAnalyticsResponse,
    UserAnalyticsQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/analytics/users/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result ? [{ type: "UserAnalytics" }] : [],
  }),
  getEvidenceAnalytics: builder.query<
    EvidenceAnalyticsResponse,
    EvidenceAnalyticsQueryParams
  >({
    query: (queryParams) => ({
      url: createUrl("/analytics/evidence/", queryParams),
      method: "GET",
    }),
    providesTags: (result): TagType[] =>
      result ? [{ type: "EvidenceAnalytics" }] : [],
  }),
});

export default analyticsService;
